import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "InfoModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String,
    default: "",
  },
  confirmButtonTitle: {
    type: String,
    default: "",
  },
},
  emits: ["onClickConfirmButton"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const route = useRoute();

const header = ref<HTMLElement>();
const body = ref<HTMLElement>();

const hasConfirmButton = props.confirmButtonTitle.length > 0;
const showModal = ref(true);

const onClickConfirmButton = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
};

const onAfterLeaveTransition = () => {
  emit("onClickConfirmButton");
};

onMounted(() => {
  route.meta.onBackHandlerList.push(onClickConfirmButton);
  header.value?.classList.add("align-left");
  body.value?.classList.add("align-left");
});

const __returned__ = { props, emit, route, header, body, hasConfirmButton, showModal, onClickConfirmButton, onAfterLeaveTransition }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})